import { HARBOR_FACTS } from '@/lib/harbor-facts';

const nunito = {
  fontFamily:
    "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
};

type ProductFactBlurbProps = {
  className?: string;
};

export function ProductFactBlurb({ className = '' }: ProductFactBlurbProps) {
  return (
    <p
      className={`mx-auto mt-6 max-w-2xl text-base leading-relaxed text-gray-700 ${className}`.trim()}
      style={nunito}
    >
      {HARBOR_FACTS.quote}
    </p>
  );
}
